//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  btnDiv: {
    marginBottom: 20,
  },
  searchInput: {
    width: 400,
    borderRadius: 20,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  responsiveTable: {
    width: "100%",
    overflowX: "auto",
    // fixed column widths keep "Created By" and "Edit" close together
    "& table": {
      tableLayout: "fixed",
      width: "100%",
      minWidth: 1100,
    },
    "& th, & td": {
      wordBreak: "break-word",
    },
    "& th:nth-child(1), & td:nth-child(1)": { width: "5%" },    // SNo
    "& th:nth-child(2), & td:nth-child(2)": { width: "10%" },   // Promo Code
    "& th:nth-child(3), & td:nth-child(3)": { width: "16%" },   // Description
    "& th:nth-child(4), & td:nth-child(4)": { width: "7%" },    // Plan
    "& th:nth-child(5), & td:nth-child(5)": { width: "9%" },    // Discounted Price
    "& th:nth-child(6), & td:nth-child(6)": { width: "9%" },    // Start Date
    "& th:nth-child(7), & td:nth-child(7)": { width: "9%" },    // End Date
    "& th:nth-child(8), & td:nth-child(8)": { width: "7%" },    // Is Active
    "& th:nth-child(9), & td:nth-child(9)": { width: "9%" },    // Created On
    "& th:nth-child(10), & td:nth-child(10)": { width: "15%" }, // Created By
    "& th:nth-child(11), & td:nth-child(11)": { width: "4%", textAlign: "center" }, // Edit
    // pagination on the left, under the table
    "& nav": {
      display: "flex",
      justifyContent: "flex-start",
      marginTop: 15,
      marginBottom: 10,
    },
  },
  // inline filter panel (compact)
  filterPanel: {
    display: "inline-block",
    maxWidth: "100%",
    backgroundColor: "#ececec",
    border: "1px solid #9e9e9e",
    borderRadius: 12,
    boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
    padding: "10px 18px 12px",
    marginBottom: 15,
  },
  filterColumn: {
    minWidth: 280,
    "&:not(:last-child)": {
      borderRight: "1px solid #000",
    },
  },
  filterHeading: {
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 2,
  },
  filterOptions: {
    display: "flex",
    flexWrap: "wrap",
    columnGap: 18,
    "& .MuiFormControlLabel-label": {
      fontSize: 14,
    },
  },
  filterFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 18,
    marginTop: 6,
  },
  filterClose: {
    color: "#1e88e5",
    textDecoration: "underline",
    textTransform: "uppercase",
    fontSize: 14,
    cursor: "pointer",
  },
  applyFilterBtn: {
    color: "#fff",
    backgroundColor: "#4472c4",
    fontSize: 14,
    width: 120,
    height: 32,
    border: "none",
    borderRadius: 5,
    cursor: "pointer",
    fontFamily: "segoe-ui",
  },
  // buttons (same blue as the other admin screens)
  filterBtn: {
    color: "#fff",
    width: "120px",
    height: "35px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "segoe-ui",
    borderRadius: 5,
    backgroundColor: "#0a72ba",
    border: "none",
    marginRight: 10,
    "@media (max-width: 600px)": {
      marginTop: "4rem",
    },
  },
  exportBtn: {
    color: "#fff",
    width: "120px",
    height: "35px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "segoe-ui",
    borderRadius: 5,
    backgroundColor: "#0a72ba",
    border: "none",
    marginRight: 10,
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
    "@media (max-width: 600px)": {
      marginTop: "4rem",
    },
  },
  createBtn: {
    color: "#fff",
    width: "120px",
    height: "35px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "segoe-ui",
    borderRadius: 5,
    backgroundColor: "#0a72ba",
    border: "none",
    "@media (max-width: 600px)": {
      marginTop: "4rem",
    },
  },
  CSVlink: {
    display: "none",
  },
  // dialog
  closeIcon: {
    position: "absolute",
    top: 12,
    right: 12,
    cursor: "pointer",
  },
  popupBtnDiv: {
    display: "flex",
    justifyContent: "center",
    gap: 12,
    marginTop: 25,
    marginBottom: 10,
  },
  submitBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    height: 36,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  cancelBtn: {
    color: "#305698",
    backgroundColor: "#fff !important",
    fontSize: 15,
    border: "1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    height: 36,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#fff !important",
    },
  },
  errorMsg: {
    color: "red",
    fontSize: "12px",
    display: "block",
    marginTop: "4px",
  },
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },
}));